import React from 'react'
import Navigation from './shared/components/Navigation'
import { Switch, Route, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import ArticleLayout from './shared/components/ArticleLayout'
import { navigation } from './shared/constants/navigation'
import MobileNavigation from './shared/components/MobileNavigation'
import Footer from './shared/components/Footer'

export default function App() {
    const location = useLocation()

    if (location && location.pathname === '/compare')
        document.querySelector('body')?.scrollTo(0, 0)

    return (
        <>
            <Navigation />
            <MobileNavigation />

            <main className="flex-1 w-full max-w-screen-md px-4 py-8">
                <AnimatePresence mode="wait">
                    <Switch location={location} key={location.pathname}>
                        {navigation.map((item) => (
                            <Route exact path={item.href} key={item.href}>
                                <ArticleLayout title={item.title}>
                                    {item.component}
                                </ArticleLayout>
                            </Route>
                        ))}
                    </Switch>
                </AnimatePresence>
            </main>

            <Footer />
        </>
    )
}
